@if (simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.washing
  && !statesService.states.walking) {
  <app-dog
    >
  </app-dog>
}

@if (statesService.states.drinking
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.washing
  && !statesService.states.walking) {
  <app-water
    >
  </app-water>
}

@if (statesService.states.eating
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.playing
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-eating
    >
  </app-eating>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Herumtollen'
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-frolic
    >
  </app-frolic>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Ballspielen'
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-football
    >
  </app-football>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Apportieren'
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-tennisball
    >
  </app-tennisball>
}

@if (statesService.states.playing
  && statesService.playingGame === 'Kuscheln'
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-cuddling
    >
  </app-cuddling>
}

@if (statesService.states.walking
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.eating
  && !statesService.states.drinking
  && !statesService.states.wiping
  && !statesService.states.showPills
  && !statesService.states.playing) {
  <app-walking
    >
  </app-walking>
}

@if (statesService.states.wiping
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.showPills
  && !statesService.states.walking) {
  <app-broom
    >
  </app-broom>
}

@if (statesService.states.showPills
  && simulation.pet.life > 0
  && !statesService.states.washing
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.wiping
  && !statesService.states.walking) {
  <app-pills
    >
  </app-pills>
}

@if (statesService.states.washing
  && !statesService.states.showPills
  && simulation.pet.life > 0
  && !statesService.showBox
  && !statesService.states.drinking
  && !statesService.states.eating
  && !statesService.states.playing
  && !statesService.states.wiping
  && !statesService.states.walking) {
  <app-washing
    >
  </app-washing>
}
